module.exports = {
    handleData: {
        REQUIRED_ONLY: 'requiredOnly',
        STRING: 'string',
        INT: 'int',
        SMALLINT: 'smallint',
        TINYINT: 'tinyint',
        FLOAT: 'float',
        NUMBER: 'number',
        DATE: 'datetime',
        BOOLEAN: 'Boolean',
    },

    changeTypeData: {
        DATE_TO_STRING: 'date_to_string',
        STRING_TO_DATE: 'string_to_date',
        CHECK_NUMBER_NULL_REQUIRED: 'check_number_null_req',
        CHECK_NUMBER_NULL: 'check_number_null',
        STRING_TO_BOOLEAN: 'string_to_boolean'
    },


    LIMIT_FILE_SIZE: 1048576 * 10, //1048576 = 1MB
    LIMIT_IMAGE_SIZE: 1048576 * 10,//1048576 = 1MB
    IMPORT_SAMPLE_FILE_PATH: 'file/FileExcelMau/',
    GUIDE_FILE_PATH: 'file/HDSD/',


    ENABLED_SELECTION: [{ id: null, name: "--- Tất cả ---" }, { id: true, name: "Bật" }, { id: false, name: "Tắt" }],
    GIOITINH: [{ id: 0, name: "Nam" }, { id: 1, name: "Nữ" }],
    QUOCTE: [{ id: 0, name: "Trong nước" }, { id: 1, name: "Quốc tế" }],
    ACCEPT_TYPE_IMG: '.jpeg, .jpg, .png',
    ACCEPT_TYPE_HOSO: '.jpeg, .jpg, .png, .pdf, .doc, .docx, .xls, .xlsx',
    ACCEPT_TYPE_EXCEL: '.xlsx,.xls',
    LOAIDIADIEM_CONGTY: 4,
    LOAIDIADIEM_DIEMDULICH: 1,
    LOAIDIADIEM_DIEMTIENICH: 2,
    PHANLOAIDIADIEM_CONGTY: 29,
    PHANLOAIDIADIEM_CONGTYVIENTHONG: 29,

    NAVIGATECODE_VALUE: {
        DETAIL: 'detail',
        CREATE: 'create',
        UPDATE: 'update',
        DELETE_TEMP: 'delete',
        RESTORE: 'restore',
        DELETE: 'deleteReal',
        OFF_ENABLED: 'offEnabled',
        ON_ENABLED: 'onEnabled',
        OFF_IOC_ENABLED: 'offEnabledIOC',
        ON_IOC_ENABLED: 'onEnabledIOC',
        //----------------Other
        IMPORT_EXCEL: 'importExcel'
    },

    TABLEBUTTON: {
        VIEWDETAILMAP: 'viewDetailMap',
        VIEWDETAIL: 'viewDetail',
        EDIT: 'edit',
        DELETE: 'delete',
        RESTORE: 'restore',
        DELETE_REAL: 'deleteReal',
    },

    NAVIGATECODE_LIST: [
        {
            code: 'detail',
            title: 'Chi tiết',
        },
        {
            code:  'create',
            title: 'Tạo mới',
        },
        {
            code: 'update',
            title: 'Cập nhật',
        },
        {
            code: 'delete',
            title: 'Xóa',
        },
        {
            code: 'restore',
            title: 'Khôi phục',
        },
        {
            code: 'deleteReal',
            title: 'Xóa hoàn toàn',
        },
        {
            code: 'offEnabled',
            title: 'Tắt hiển thị',
        },
        {
            code: 'onEnabled',
            title: 'Bật hiển thị',
        },
        {
            code: 'offEnabledIOC',
            title: 'Tắt đồng bộ IOC',
        },
        {
            code: 'onEnabledIOC',
            title: 'Bật đồng bộ IOC',
        },
    ],

    TYPEDATA_LIST: {
        CURRENT_LIST: {
            id: 1,
            title: "Danh sách hiện tại",
        },
        DELETED_LIST: {
            id: 2,
            title: "Danh sách đã xóa",
        },
    },

    IS_CHIEUSANG: [
        {
            id: "true",
            name: "Chiếu sáng"
        },
        {
            id: "false",
            name: "Giao thông"
        }
    ]
}